<ion-tabs [environmentInjector]="environmentInjector"></ion-tabs>
<app-banner-cookies></app-banner-cookies>
